import React from 'react';
import { Stack, Text } from '@solvhealth/jigsaw';
import SlideInBottomDialog from '~/components/SolvDesignSystem/Dialog/SlideInBottomDialog';
import { SolvButton } from '~/components/SolvDesignSystem';
import CenteredDialog from '~/components/SolvDesignSystem/Dialog/CenteredDialog';
import Hidden from '~/components/SolvDesignSystem/Hidden';
import { MEMBERSHIP_SUPPORT_EMAIL } from '~/components/Membership/constants';

type OwnProps = {
  closeModal?: (...args: any[]) => any;
  open?: boolean;
};

const defaultProps = {
  open: false,
};

type Props = OwnProps & typeof defaultProps;

const MemberContactUsModal = (props: Props) => {
  const { open, closeModal } = props;

  const content = (
    <Stack alignItems="left" margin="auto" maxWidth={450} paddingBottom={5} space={1}>
      <Text variant="h2"> We'd be happy to help</Text>
      <Text paddingBottom={2}>
        Please email us at{' '}
        <a href={`mailto:${MEMBERSHIP_SUPPORT_EMAIL}`}>{MEMBERSHIP_SUPPORT_EMAIL}</a>.
      </Text>
      <SolvButton color="primary" fullWidth onClick={closeModal} variant="contained">
        OK
      </SolvButton>
    </Stack>
  );

  return (
    <>
      <Hidden only={['xs']}>
        <CenteredDialog onClose={closeModal} open={open}>
          {content}
        </CenteredDialog>
      </Hidden>
      <Hidden only={['sm', 'md', 'lg', 'xl']}>
        <SlideInBottomDialog onClose={closeModal} open={open} shouldOffsetBottomNav={false}>
          {content}
        </SlideInBottomDialog>
      </Hidden>
    </>
  );
};

export default MemberContactUsModal;
